export default __webpack_public_path__ + "78279eb096e76213ee2bcb369ae6725d.svg";